import { useRef } from 'react'

const AlertTable = (props) => {

    const { availableAlert, masterPropertyID, ProSta, labelCol } = props;
    const openModalRef = useRef(null);

    const day = new Date().getDate()
    const month = new Date().getMonth()
    const year = new Date().getFullYear()

    const filteredAlerts = availableAlert?.filter((alert) => alert?.AlertDateTo ? new Date(alert?.AlertDateTo) >= new Date(year, month, day) : alert) ?? [];

    const handleAlertClick = (alert) => {
        if (alert?.AlertID != null) {
            window.dispatchEvent(new CustomEvent('openAlertEdit', { detail: { alertId: alert.AlertID } }));
            openModalRef.current?.click();
        }
    };

    return (

        <div className='d-flex bt bb align-items-center' style={{ gap: '10px' }}>
            <div className={`${labelCol ? labelCol : "col-lg-1"}  text-nowrap`}>
                {masterPropertyID && (ProSta === 'true' || ProSta === true) && (
                    <span data-toggle="modal" data-target="#MasterAlert" style={{ cursor: "pointer" }} className='alert-link pt-1'>Alerts :</span>
                )}
            </div>

            <div className='alert-name col-lg-10 d-flex align-items-center ml-1' style={{
                alignContent: "center", height: "30px", overflowY: 'auto',
            }} >
                <button
                    ref={openModalRef}
                    type="button"
                    data-toggle="modal"
                    data-target="#MasterAlert"
                    style={{ display: 'none' }}
                    aria-hidden="true"
                />
                {filteredAlerts?.length > 0 ?
                    filteredAlerts?.map((alert) => (
                        <span
                            key={alert?.AlertID ?? alert?.AlertChar}
                            style={{ margin: "0 2px 0 2px", padding: "1px 4px 1px 4px", border: "1px solid", background: `${alert?.BackColor}`, color: alert?.BackColor && alert?.ForeColor, cursor: "pointer" }}
                            onClick={() => handleAlertClick(alert)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleAlertClick(alert); }}
                        >
                            {alert?.AlertChar}
                        </span>
                    ))
                    :
                    <>
                        {
                            masterPropertyID && (ProSta === 'true' || ProSta === true) &&
                            <span data-toggle="modal" data-target="#MasterAlert" style={{ cursor: "pointer", marginLeft: "20px", color: "blue", fontWeight: "bold" }} className='alert-link pt-1'>
                                Add Alert
                            </span>
                        }
                    </>
                }
            </div>
        </div>

    )
}

export default AlertTable









